import axios from 'axios';
import React from 'react';
import 'react-alice-carousel/lib/alice-carousel.css';
import { isMobile } from 'react-device-detect';
import { withRouter } from 'react-router-dom';
import ScaleLoader from 'react-spinners/ScaleLoader';
import styled from 'styled-components';
import { TossPaymentModal, getUuid } from '../../_utils/toss_paymet';
import images from '../../assets';
import { ChooseCardOrPayparModal } from '../../components/ai_generate/generateView';
import { ContentsWrap, HSLine, HorizontalSp, MediaQuery, RowCenter, VerticalSp } from '../../components/Common';
import { IsShortOfCreditModal } from '../../components/designs/DesignPage';
import { RotatedImage } from '../../components/mypage/AIGenerateResult';
import { RadioOption } from '../../components/mypage/Mypage';

import {
  CreditPrice,
  DesignTitle,
  LicenseIcoSpec,
  LicensePrice,
  LicenseSpec,
  MainPreview,
  MaterialLbl,
  PreMaskTag,
  PreviewArea,
} from '../../components/designs/unityTestDetailView';

import queryString from 'query-string';
import { withTranslation } from 'react-i18next';
import Store from 'store';
import apiClient from '../../_utils/axios';
import {
  CartButton,
  CustomButton,
  CustomButtonMobile,
  LicensBlock,
  LicenseType,
} from '../../components/ai_generate/generateDetailView';
import { BasketModal, PlzLoginModal } from '../../components/designs/DesignPage';
import { CURRENCY_CONFIG } from '../../libs/common';
import { getCurrentLang, getStringByLang } from '../../libs/lang';
import { marketingApi } from '../../marketing-api';
import store from '../../store';
import CurrencyService from '../../libs/class/CurrencyService';

const MyTextarea = styled.textarea`
  width: calc(100% - 12px);
  border: 1px solid #a0a0a0;
  resize: none;
  font-family: 'NSCJKrR';
  border-radius: 3px;
  font-size: 14px;
  /* &:hover {
    background: palevioletred;
  }; */
  &:focus-visible {
    border: 1px solid #a0a0a0;
  }
  /* &[data-focus-visible="true"] * {
    outline: none;
  } */
`;

// 6인치로 생성되는 모티브 들만
const ALLOWED_STYLES = ['floral.json', 'camouflage.json', 'animal_skin.json'];

class AIGenerateDetail extends React.Component {
  state = {
    zoomval: 10,
    maskpng: '',
    preview_large: '',
    preview_large: '',
    licensetype: 'Basic',
    similar_responsive: {
      0: { items: 1 },
      630: { items: 2 },
      900: { items: 3 },
      1200: { items: 4 },
      1530: { items: 5 },
    },
    rating: 5,
    comment: '',
    showshare: false,
    showbasket: false,
    showfavmodal: false,
    showPlzLoginModal: false,
    isLackCreditModal: false,
    overmtrl: '',
    viewData: '',
    is_download: 0,
    is_buy: false,
    product_id: '',
    category: '',
    style: 'default',
    similar_design: [],
    other_design: [],
    reviewList: [],
    page: 1,
    total_pages: 0,
    total: 0,
    reviewUse: false,
    interestTarget: this.props.match.params.id,
    loading: true,
    reportShow: false,
    reportReason: '',
    mainPreviewSize: 'large',
    isUnityView: false,
    completeLoaded: false,
    purchasetype: 'general_pay',
    userCredit: 0,
    paymethodmodal: false,
    pay_amount: 0,
    size: '12*12in',
    verticalHorizonRadio: [1, 1],
    convertingArray: [],
    downloadingArray: [],
    tossPaymentModal: false,
    amount: 0,
    productName: '',
  };

  componentDidMount = async () => {
    const params = new URLSearchParams(window.location.search);
    // 크레딧 토스 구입
    const orderId = params.get('orderId');
    const paymentKey = params.get('paymentKey');
    const paymentType = params.get('paymentType');
    const amount = params.get('amount');

    await this.getView();

    if (paymentType === 'NORMAL' || paymentType === 'BRANDPAY') {
      const paymentInfo = {
        orderId: orderId,
        paymentKey: paymentKey,
        paymentType: paymentType,
        amount: amount,
      };
      await this.goPurchase('toss', paymentInfo);
    }

    if (!Store.get('accessToken')) this.showPlzLoginModal();
  };

  componentDidUpdate = (prevProps, prevState) => {
    const prevConvertingArray = prevState.convertingArray;
    const currentConvertingArray = this.state.convertingArray;

    if (prevConvertingArray !== currentConvertingArray) {
      this.convertStateChecker();
    }

    if (this.props.match.params.id !== prevProps.match.params.id) {
      window.scrollTo(0, 'top');
      this.getView();

      if (!Store.get('accessToken')) this.showPlzLoginModal();
    }
  };

  // 3초에 1번씩 요청 보내서 상태 확인하고 버튼 바꿔주는 기능
  convertStateChecker = () => {
    this.interval = setInterval(async () => {
      const currentConvertingArray = this.state.convertingArray;
      currentConvertingArray.forEach(async (item) => {
        // 각 요소에 대한 작업 수행
        const res = await apiClient.get(`/generate/convert/${item}`);
        if (res.data.data.is_convert === true) {
          const newConvertingArray = currentConvertingArray.filter(
            (item) => parseInt(item) !== res.data.data.product_id,
          );
          this.setState({ convertingArray: newConvertingArray });
          this.downloadImage(
            `${process.env.REACT_APP_S3_BUCKET_DOMAIN}/${res.data.data.ai_generate.res_img_path}`,
            res.data.data.product_id,
            'jpg',
          );
          this.downloadImage(
            `${process.env.REACT_APP_S3_BUCKET_DOMAIN}/${res.data.data.ai_generate.res_psd_path}`,
            res.data.data.product_id,
            'psd',
          );

          clearInterval(this.interval);
        }
      });
    }, 3000);
  };

  closeTossPaymentModal = () => {
    this.setState({ tossPaymentModal: false });
  };

  openTossPaymentModal = () => {
    this.setState({ tossPaymentModal: true });
  };

  onMaskImg = (val) => {
    this.setState({ maskpng: val });
  };

  closeFavModal = () => {
    this.setState({ showfavmodal: false });
  };

  showPlzLoginModal = () => {
    const query = queryString.parse(window.location.search);
    if (query.login_popup && query.login_popup === 'false') {
      return;
    }

    this.setState({ showPlzLoginModal: true });
  };

  closePlzLoginModal = () => {
    this.setState({ showPlzLoginModal: false });
  };

  closeIsLakeCreditModal = () => {
    this.setState({ isLackCreditModal: false });
  };

  closeBasketModal = () => {
    this.setState({ showbasket: false });
  };

  ShowBasketModal = () => {
    this.setState({ showbasket: true });
  };

  closePaymethodModal = () => {
    this.setState({ paymethodmodal: false });
  };

  ShowPaymethodModal = async () => {
    await this.setStateAsync({ paymethodmodal: true });
  };

  SelectFstPayMethod = () => {
    this.closePaymethodModal();

    this.goPurchase('eximbay');
  };

  SelectSndPayMethod = () => {
    this.closePaymethodModal();
    this.goPurchase('paypal');
  };

  onGoAIGeneratePrice = () => {
    this.props.history.push('/generate/intro/1');
  };

  goDesignerShop = (id) => {
    this.props.history.push(`/designer/shop/${id}`);
  };

  setStateAsync(state) {
    return new Promise((resolve) => {
      this.setState(state, resolve);
    });
  }
  // 이미지 사이즈 찾는 함수
  getImageDimensions(imageUrl, style) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = function () {
        const width = Math.round((this.width / 300) * 1000) / 1000;
        const height = Math.round((this.height / 300) * 1000) / 1000;
        const aspectRatio = width / height;
        let size = '12*12in';
        // 이미지의 가로와 세로 크기
        let betterV = Math.max(width, height); // 두 길이 중 더 긴 길이
        let lowV = Math.min(width, height); // 두 길이 중 더 짧은 길이

        // 비율 계산
        let radioVal = betterV / lowV;
        let new_size; // 조정된 이미지 크기
        let verticalHorizonRadio;
        // 이미지 크기 조정

        new_size = ALLOWED_STYLES.includes(style) ? [6, 6] : [12, 12];
        verticalHorizonRadio = [1, 1];
        console.log('🚀 ~ AIGenerateDetail.js:265 ~ AIGenerateDetail ~ getImageDimensions ~ new_size:', new_size);

        size = new_size[0] + '*' + new_size[1] + 'in';
        resolve({ width, height, aspectRatio, size, verticalHorizonRadio });
      };

      img.onerror = function () {
        reject(new Error('Failed to load image'));
      };
      img.src = imageUrl;
    });
  }

  getView = async () => {
    const id = this.props.match.params.id;
    const res = await apiClient.get(`/generate/result/detail/${id}`);
    if (res.data.code === 200) {
      await this.setStateAsync({
        viewData: res.data.data,
        preview_large: res.data.data.res_preview_crop_path,
        preview_large: res.data.data.res_preview_large_path,
        maskpng: `${images.mask_img_0}`,
        is_download: res.data.data.is_download,
        product_id: res.data.data.idx,
        is_buy: res.data.data.is_buy,
        userCredit: res.data.userCredit,
        productName: res.data.data.img_name,
        style: res.data.data.req_style || 'default',
      });

      let amount = 0;
      if (Store.get('lang') === 'kr') {
        amount = store.getState().generate_price[0]?.krw;
      } else if (Store.get('lang') === 'ur') {
        amount = store.getState().generate_price[0]?.euro;
      } else {
        amount = store.getState().generate_price[0]?.usd;
      }

      const { width, height, aspectRatio, size, verticalHorizonRadio } = await this.getImageDimensions(
        res.data.data.res_preview_large_path,
        res.data.data.req_style,
      );
      this.setState({
        loading: false,
        isUnityView: false,
        size: size,
        verticalHorizonRadio: verticalHorizonRadio,
        amount: amount,
      });
    } else {
      if (Store.get('lang') === 'kr') {
        alert(res.data.message_ko);
      } else {
        alert(res.data.message_en);
      }
      this.props.history.push('/main');
    }
  };

  getCart = async () => {
    const id = this.props.match.params.id;
    // marketingApi.useAddToCartEffect(this.state.viewData, window.prd_price, this.state.licensetype);
    const res = await apiClient.post(`/generate/cart/add/product/${id}`);

    if (res) {
      this.ShowBasketModal();
    }
  };

  goBasket = () => {
    this.props.history.push('/mypage/generate/basket');
  };

  //크레딧으로 구매하기 - 크레딧결제 (purchasetype :  'credit_pay')
  goPurchseWithCredit = async () => {
    //로그인을 했는지 확인
    if (!Store.get('accessToken')) {
      this.setState({
        showPlzLoginModal: true,
      });

      return;
    }

    let currency = '',
      products = [],
      order_name = '',
      amount = 0;

    const lang = getCurrentLang();

    if (lang === 'kr') {
      amount = store.getState().generate_price[0]?.krw;
    } else if (lang === 'ur') {
      amount = store.getState().generate_price[0]?.euro;
    } else {
      amount = store.getState().generate_price[0]?.usd;
    }

    const name = store.getState().name,
      phone = store.getState().phone,
      email = store.getState().email;

    //주문 번호 생성 시 필요
    let uuid = '';
    let possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var i;
    for (i = 0; i < 7; i++) uuid += possible.charAt(Math.floor(Math.random() * possible.length));

    //user 테이블의 cretit_amount의 값을 1 감소 시키고, ai_generate_order에 구매 내역을 insert 할 수 있도록 백엔드 함수 호출
    products.push({
      id: this.state.product_id,
    });

    if (lang === 'kr') {
      currency = 'KRW';
    } else if (lang === 'ur') {
      currency = 'EUR';
    } else {
      currency = 'USD';
    }

    //주문명
    order_name = this.state.viewData.img_name;

    //크레딧으로 결제 처리 (기존 보유한 크레딧(user테이블에서 credit_amount 컬럼의 값 가져오기) 에서 1 차감)
    const res = await apiClient.post('/generate/creditpayment', {
      amount,
      order_no: uuid.toUpperCase(),
      currency,
      name,
      phone,
      email,
      lang,
      products,
      pay_method: 'credit',
      product_credit_amount: 1,
      use_credit: 'Y',
    });

    if (res && res.status === 200) {
      await this.setStateAsync({ orderList: res.data.order });
      //await this.getScreenshotHandler(res.data.order.order_id);
      alert(getStringByLang(res.data.message_ko, res.data.message_en, res.data.message_jp));
      this.props.history.push('/mypage/generate/purchase');
    } else if (res.status === 201) {
      this.setState({
        isLackCreditModal: true,
      });
      return;
    }
  };

  //구매하기 - 일반결제 (purchasetype :  'general_pay')
  goPurchase = async (type, payment_info) => {
    const location = process.env.REACT_APP_LOCATION;
    if (!Store.get('accessToken')) {
      this.setState({
        showPlzLoginModal: true,
      });
      return;
    }
    const uuid = crypto.randomUUID();

    let IMP = window.IMP;
    let currency = '',
      products = [],
      order_name = '';

    let amount = this.state.amount;
    const name = store.getState().name,
      phone = store.getState().phone,
      email = store.getState().email;
    const lang = getCurrentLang();
    //본인 인증을 하지 않아도 결제가 되도록 수정

    products.push({
      id: this.state.product_id,
    });

    if (lang === 'kr') {
      currency = 'KRW';
    } else if (lang === 'ur') {
      currency = 'EUR';
    } else {
      currency = 'USD';
    }

    order_name = this.state.viewData.img_name;

    let reqBody = {
      popup: true,
      merchant_uid: uuid.toUpperCase(),
      name: order_name,
      amount: amount,
      buyer_email: email,
      currency,
    };

    const isTester = location === 'develop' || store.getState().username === process.env.REACT_APP_MANAGER;
    console.log('🚀 ~ BasketList.js:364 ~ BasketList ~ isTester:', isTester);
    if (type === 'eximbay') {
      reqBody['pg'] = isTester ? 'eximbay.1849705C64' : 'eximbay.13AE2B20B2';
      reqBody['pay_method'] = 'card';
    } else {
      reqBody['pg'] = isTester ? 'paypal.sb-d4n9k30675837_api1.business.example.com' : 'paypal';
      reqBody['pay_method'] = 'paypal';
    }

    const completed = async (res) => {
      if (res.message_en === 'Failed Error') {
        return this.props.history.push(`generate/result/detail/${this.props.match.params.id}`);
      } else {
        await this.setStateAsync({ orderList: res.data.order });
        if (lang === 'kr') {
          alert(res.data.message_ko);
        } else {
          alert(res.data.message_en);
        }
        this.props.history.push('/mypage/generate/purchase');
      }
    };

    if (type === 'toss') {
      const res = await apiClient.post('/generate/payment', {
        amount: payment_info.amount,
        order_no: uuid.toUpperCase(),
        currency,
        name,
        phone,
        email,
        lang,
        payment_info,
        products,
        pay_method: 'toss',
        pay_pg: 'toss',
      });
      completed(res);
    } else {
      IMP.request_pay(reqBody, async (rsp) => {
        if (rsp.success) {
          const res = await apiClient
            .post('/generate/payment', {
              amount,
              order_no: uuid.toUpperCase(),
              currency,
              name,
              phone,
              email,
              lang,
              payment_info: JSON.stringify(rsp),
              products,
              pay_pg: type,
              pay_method: reqBody['pay_method'],
            })
            .catch(() => {
              if (lang === 'kr') {
                alert(res.data.message_ko);
              } else {
                alert(res.data.message_en);
              }
              this.props.history.push(`generate/result/detail/${this.props.match.params.id}`);
            });

          completed(res);
        }
      });
    }
  };

  handleMouseEnter = (itemId) => {
    this.setState({ overmtrl: itemId });
  };

  handleMouseLeave = () => {
    this.setState({ overmtrl: '' });
  };

  downloadImage = async (url, downloadingProductId, img) => {
    try {
      // downloadingArray 안에 product_id 설정. 다운로드 시, jpg & psd가 받아짐. psd가 용량이 더 커서 일반적으로 psd를 진행도
      if (img === 'psd') {
        const addData = [downloadingProductId, 0];
        const currentDownloadingArray = this.state.downloadingArray;
        const newDownloadingArray = [...currentDownloadingArray, addData];
        this.setState({ downloadingArray: newDownloadingArray });
      }

      // HTTP GET 요청 보내고 응답 받기
      const response = await axios.get(url, {
        responseType: 'blob',
        onDownloadProgress: (progressEvent) => {
          if (img === 'psd' && progressEvent.lengthComputable) {
            const percentComplete = (progressEvent.loaded / progressEvent.total) * 100;
            const currentDownloadingArray = this.state.downloadingArray;
            const newDownloadingArray = currentDownloadingArray.map((item) => {
              if (item[0] === downloadingProductId) {
                // 해당하는 ID를 가진 항목의 두 번째 값을 업데이트합니다.
                return [downloadingProductId, percentComplete.toFixed(2)];
              }
              return item;
            });
            // 상태를 업데이트합니다.
            this.setState({ downloadingArray: newDownloadingArray });
          }
        },
      });

      // Blob을 URL.createObjectURL을 사용하여 다운로드 가능한 링크로 변환
      const imageUrl = URL.createObjectURL(response.data);

      // 다운로드 링크 생성
      const downloadLink = document.createElement('a');
      const urlParts = url.split('/');
      downloadLink.href = imageUrl;
      downloadLink.download = urlParts[urlParts.length - 1]; // 파일 이름 설정
      downloadLink.click();

      // 사용이 끝난 URL 해제
      // URL.revokeObjectURL(imageUrl);

      if (img === 'psd') {
        const currentDownloadingArray = this.state.downloadingArray;
        const newDownloadingArray = currentDownloadingArray.filter((item) => item[0] !== downloadingProductId);
        this.setState({ downloadingArray: newDownloadingArray });
      }
    } catch (error) {
      console.error('다운로드 중 오류가 발생했습니다:', error);
    }
  };

  showProductList = (index) => {
    const { order_no_ref, product_name_ref, product_receipt_ref, product_amount_ref } = this;
    const orderNoWidth = order_no_ref?.getBoundingClientRect().width;
    const productNameWidth = product_name_ref?.getBoundingClientRect().width;
    const productReceiptWidth = product_receipt_ref?.getBoundingClientRect().width;
    const productAmountWidth = product_amount_ref?.getBoundingClientRect().width;

    if (orderNoWidth && productNameWidth) {
      const padding = isMobile ? 0 : 60;
      const size = orderNoWidth + productNameWidth - padding;
      this.setState((state) => ({
        list: state.list.map((item2, k) => {
          if (k === index) {
            return {
              ...item2,
              ditemopen: !item2.ditemopen,
            };
          }
          return item2;
        }),
        childWidthSize: size,
        childAmountSize: productAmountWidth,
        childDownloadSize: productReceiptWidth,
      }));
    }
  };

  downloadImageOne = async () => {
    const { product_id } = this.state;
    const res = await apiClient.get(`/generate/download/one/${product_id}`);

    if (res) {
      const is_convert = res.data.data.is_convert;
      if (is_convert === true) {
        const img_url = res.data.data.ai_generate.res_img_path;
        const psd_url = res.data.data.ai_generate.res_psd_path;
        const downloadingProductId = res.data.data.ai_generate.product_id;

        this.downloadImage(`${process.env.REACT_APP_S3_BUCKET_DOMAIN}/${img_url}`, downloadingProductId, 'jpg');
        this.downloadImage(`${process.env.REACT_APP_S3_BUCKET_DOMAIN}/${psd_url}`, downloadingProductId, 'psd');
      } else {
        const converingProductId = res.data.data.ai_generate.product_id;
        const currentConvertingArray = this.state.convertingArray;
        const newConvertingArray = [...currentConvertingArray, converingProductId];
        this.setState({ convertingArray: newConvertingArray });
      }
    }
  };

  render() {
    const { t } = this.props;
    const {
      maskpng,
      licensetype,
      similar_responsive,
      rating,
      comment,
      showshare,
      showfavmodal,
      showbasket,
      overmtrl,
      reportShow,
      showPlzLoginModal,
      isLackCreditModal,
      paymethodmodal,
      pay_amount,
      size,
    } = this.state;
    const {
      viewData,
      preview_large,
      preview_cropped,
      is_download,
      is_buy,
      category,
      style,
      similar_design,
      other_design,
      reviewList,
      page,
      total_pages,
      total,
      loading,
      reviewUse,
      interestTarget,
      reportReason,
      mainPreviewSize,
      purchasetype,
      userCredit,
      convertingArray,
      downloadingArray,
    } = this.state;

    const lang = getCurrentLang();
    var license = '0';
    Boolean(viewData.license === 'Premium') ? (license = '1') : (license = '0');
    let cost = '',
      pattern = '';

    if (cost && !this.state.completeLoaded) {
      marketingApi.useViewItemEffect(viewData, viewData.is_sale ? cost * 0.8 : cost);
      this.setState({ completeLoaded: true });
    }
    window.prd_price = viewData.is_sale ? cost * 0.8 : cost;

    let button, downloading;
    if (convertingArray.length > 0) {
      button = 'converting';
    } else {
      button = 'download';
    }

    if (downloadingArray.length > 0) {
      button = 'downloading';
      downloading = downloadingArray[0][1];
    }

    const currencyService = new CurrencyService(store.getState().license_price);
    cost = currencyService.getProductCost('Classic');

    return (
      <>
        <ContentsWrap>
          <VerticalSp sp={'4.8vw'} />
          <VerticalSp sp={20} />
          <VerticalSp sp={'3.3vw'} />
          <RowCenter style={{ alignItems: 'flex-start' }}>
            {/* ----------------- pc ---------------------------*/}
            <MediaQuery min={1250}>
              {!loading && (
                <div style={{ width: 160 }}>
                  <PreMaskTag
                    key={`mapping-${'0'}`}
                    onMouseEnter={() => {
                      this.handleMouseEnter('tag0');
                    }}
                    onMouseLeave={this.handleMouseLeave}
                    onClick={() => {
                      marketingApi.useClickDetailPreviewEffect(
                        this.state.viewData.product_name,
                        Store.get('lang') === 'kr' ? '린넨' : 'linen',
                      );
                      this.setState({ isUnityView: false });
                      this.onMaskImg(images.mask_img_0);
                      this.setState({ mainPreviewSize: 'large' });
                    }}
                    style={{
                      border: maskpng === images.mask_img_0 ? '1px solid #fe8b07' : '1px solid  rgb(0,0,0,0)',
                    }}
                  >
                    <PreviewArea pngimg={images.mask_img_0} designimg={preview_large} width={100} />
                    {overmtrl === 'tag0' && <MaterialLbl>{Store.get('lang') === 'kr' ? '린넨' : 'linen'}</MaterialLbl>}
                  </PreMaskTag>
                  <PreMaskTag
                    key={`mapping-${'1'}`}
                    onMouseEnter={() => {
                      this.handleMouseEnter('tag1');
                    }}
                    onMouseLeave={this.handleMouseLeave}
                    onClick={() => {
                      marketingApi.useClickDetailPreviewEffect(
                        this.state.viewData.product_name,
                        Store.get('lang') === 'kr' ? '쉬폰' : 'chiffon',
                      );
                      this.setState({ isUnityView: false });
                      this.onMaskImg(images.mask_img_1);
                      this.setState({ mainPreviewSize: 'large' });
                    }}
                    style={{
                      border: maskpng === images.mask_img_1 ? '1px solid #fe8b07' : '1px solid  rgb(0,0,0,0)',
                    }}
                  >
                    <PreviewArea pngimg={`${images.mask_img_1}`} designimg={preview_large} width={100} />
                    {overmtrl === 'tag1' && (
                      <MaterialLbl>{Store.get('lang') === 'kr' ? '쉬폰' : 'chiffon'}</MaterialLbl>
                    )}
                  </PreMaskTag>
                  <PreMaskTag
                    key={`mapping-${'2'}`}
                    onMouseEnter={() => {
                      this.handleMouseEnter('tag2');
                    }}
                    onMouseLeave={this.handleMouseLeave}
                    onClick={() => {
                      marketingApi.useClickDetailPreviewEffect(
                        this.state.viewData.product_name,
                        Store.get('lang') === 'kr' ? '면' : 'cotton',
                      );
                      this.setState({ isUnityView: false });
                      this.onMaskImg(images.mask_img_2);
                      this.setState({ mainPreviewSize: 'large' });
                    }}
                    style={{
                      border: maskpng === images.mask_img_2 ? '1px solid #fe8b07' : '1px solid  rgb(0,0,0,0)',
                    }}
                  >
                    <PreviewArea pngimg={`${images.mask_img_2}`} designimg={preview_large} width={100} />
                    {overmtrl === 'tag2' && <MaterialLbl>{Store.get('lang') === 'kr' ? '면' : 'cotton'}</MaterialLbl>}
                  </PreMaskTag>
                  <PreMaskTag
                    key={`mapping-${'3'}`}
                    onMouseEnter={() => {
                      this.handleMouseEnter('tag3');
                    }}
                    onMouseLeave={this.handleMouseLeave}
                    onClick={() => {
                      marketingApi.useClickDetailPreviewEffect(
                        this.state.viewData.product_name,
                        Store.get('lang') === 'kr' ? '플라스틱' : 'plastic',
                      );
                      this.setState({ isUnityView: false });
                      this.onMaskImg(images.mask_img_3);
                      this.setState({ mainPreviewSize: 'large' });
                    }}
                    style={{
                      border: maskpng === images.mask_img_3 ? '1px solid #fe8b07' : '1px solid  rgb(0,0,0,0)',
                    }}
                  >
                    <PreviewArea pngimg={`${images.mask_img_3}`} designimg={preview_large} width={100} />
                    {overmtrl === 'tag3' && (
                      <MaterialLbl>{Store.get('lang') === 'kr' ? '플라스틱' : 'plastic'}</MaterialLbl>
                    )}
                  </PreMaskTag>
                  <PreMaskTag
                    key={`mapping-${'4'}`}
                    onMouseEnter={() => {
                      this.handleMouseEnter('tag4');
                    }}
                    onMouseLeave={this.handleMouseLeave}
                    onClick={() => {
                      marketingApi.useClickDetailPreviewEffect(
                        this.state.viewData.product_name,
                        Store.get('lang') === 'kr' ? '종이' : 'paper',
                      );
                      this.setState({ isUnityView: false });
                      this.onMaskImg(images.mask_img_4);
                      this.setState({ mainPreviewSize: 'large' });
                    }}
                    style={{
                      border: maskpng === images.mask_img_4 ? '1px solid #fe8b07' : '1px solid  rgb(0,0,0,0)',
                    }}
                  >
                    <PreviewArea pngimg={`${images.mask_img_4}`} designimg={preview_large} width={100} />
                    {overmtrl === 'tag4' && <MaterialLbl>{Store.get('lang') === 'kr' ? '종이' : 'paper'}</MaterialLbl>}
                  </PreMaskTag>
                  <PreMaskTag
                    key={`mapping-${'6'}`}
                    onMouseEnter={() => {
                      this.handleMouseEnter('tag6');
                    }}
                    onMouseLeave={this.handleMouseLeave}
                    onClick={() => {
                      this.onMaskImg(null);
                      this.setState({ isUnityView: false });
                      this.setState({ mainPreviewSize: 'cropped' });
                    }}
                    style={{
                      border: maskpng === null ? '1px solid #fe8b07' : '1px solid rgb(0,0,0,0)',
                    }}
                  >
                    <PreviewArea pngimg={images.zoom_icon} designimg={preview_large} width={100} />
                    {overmtrl === 'tag6' && <MaterialLbl></MaterialLbl>}
                  </PreMaskTag>
                  {/* 유니티 */}
                  {/* TODO: 유니티 코드 변경이후 적용 */}
                  <PreMaskTag
                    onMouseEnter={() => {
                      this.handleMouseEnter('tag7');
                    }}
                    onMouseLeave={this.handleMouseLeave}
                    onClick={() => {
                      this.onMaskImg('');
                      this.setState({ isUnityView: true, mainPreviewSize: 'large' });
                    }}
                    style={{
                      border: this.state.isUnityView === true ? '1px solid #fe8b07' : '1px solid rgb(0,0,0,0)',
                    }}
                  >
                    <img alt="" width={100} src={images.three_d_icon} />
                    {overmtrl === 'tag7' && <MaterialLbl></MaterialLbl>}
                  </PreMaskTag>
                </div>
              )}
              <HorizontalSp sp={'1vw'} />
              <div>
                {loading ? (
                  <div
                    style={{
                      width: 700,
                      height: 700,
                      textAlign: 'center',
                      display: 'table-cell',
                      verticalAlign: 'middle',
                    }}
                  >
                    <ScaleLoader color={'#fc8a06'} loading={true} size={150} />
                  </div>
                ) : (
                  <>
                    <MainPreview
                      pngimg={maskpng}
                      designimg={mainPreviewSize === 'cropped' ? preview_large : preview_large}
                      width={700}
                      verticalHorizonRadio={this.state.verticalHorizonRadio}
                      mainPreviewSize={this.state.mainPreviewSize}
                      isUnityView={this.state.isUnityView}
                      product_name={this.state.viewData.product_name}
                      product_id={this.props.match.params.id}
                    />
                  </>
                )}
              </div>
              <HorizontalSp sp={'3vw'} />
            </MediaQuery>
            {/* ----------------- 테블릿 ---------------------------*/}
            <MediaQuery max={1249}>
              <MediaQuery min={920}>
                {loading ? (
                  <div>
                    <div
                      style={{
                        width: 700,
                        height: 700,
                        textAlign: 'center',
                        display: 'table-cell',
                        verticalAlign: 'middle',
                      }}
                    >
                      <ScaleLoader color={'#fc8a06'} loading={true} size={150} />
                    </div>
                  </div>
                ) : (
                  <div>
                    <MainPreview
                      pngimg={maskpng}
                      designimg={mainPreviewSize === 'cropped' ? preview_large : preview_large}
                      width={500}
                      verticalHorizonRadio={this.state.verticalHorizonRadio}
                      mainPreviewSize={this.state.mainPreviewSize}
                      isUnityView={this.state.isUnityView}
                      product_name={this.state.viewData.product_name}
                      product_id={this.props.match.params.id}
                    />
                    <VerticalSp sp={5} />
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}
                    >
                      <PreMaskTag
                        key={`mapping-${'0'}`}
                        onMouseEnter={() => {
                          this.handleMouseEnter('tag0');
                        }}
                        onMouseLeave={this.handleMouseLeave}
                        onClick={() => {
                          marketingApi.useClickDetailPreviewEffect(
                            this.state.viewData.product_name,
                            Store.get('lang') === 'kr' ? '린넨' : 'linen',
                          );
                          this.setState({ isUnityView: false });
                          this.onMaskImg(images.mask_img_0);
                          this.setState({ mainPreviewSize: 'large' });
                        }}
                        style={{
                          border: maskpng === images.mask_img_0 ? '1px solid #fe8b07' : '1px solid  rgb(0,0,0,0)',
                        }}
                      >
                        <PreviewArea pngimg={images.mask_img_0} designimg={preview_large} width={100} />
                        {overmtrl === 'tag0' && (
                          <MaterialLbl>{Store.get('lang') === 'kr' ? '린넨' : 'linen'}</MaterialLbl>
                        )}
                      </PreMaskTag>
                      <PreMaskTag
                        key={`mapping-${'1'}`}
                        onMouseEnter={() => {
                          this.handleMouseEnter('tag1');
                        }}
                        onMouseLeave={this.handleMouseLeave}
                        onClick={() => {
                          marketingApi.useClickDetailPreviewEffect(
                            this.state.viewData.product_name,
                            Store.get('lang') === 'kr' ? '쉬폰' : 'chiffon',
                          );
                          this.setState({ isUnityView: false });
                          this.onMaskImg(images.mask_img_1);
                          this.setState({ mainPreviewSize: 'large' });
                        }}
                        style={{
                          border: maskpng === images.mask_img_1 ? '1px solid #fe8b07' : '1px solid  rgb(0,0,0,0)',
                        }}
                      >
                        <PreviewArea pngimg={`${images.mask_img_1}`} designimg={preview_large} width={100} />
                        {overmtrl === 'tag1' && (
                          <MaterialLbl>{Store.get('lang') === 'kr' ? '쉬폰' : 'chiffon'}</MaterialLbl>
                        )}
                      </PreMaskTag>
                      <PreMaskTag
                        key={`mapping-${'2'}`}
                        onMouseEnter={() => {
                          this.handleMouseEnter('tag2');
                        }}
                        onMouseLeave={this.handleMouseLeave}
                        onClick={() => {
                          marketingApi.useClickDetailPreviewEffect(
                            this.state.viewData.product_name,
                            Store.get('lang') === 'kr' ? '면' : 'cotton',
                          );
                          this.setState({ isUnityView: false });
                          this.onMaskImg(images.mask_img_2);
                          this.setState({ mainPreviewSize: 'large' });
                        }}
                        style={{
                          border: maskpng === images.mask_img_2 ? '1px solid #fe8b07' : '1px solid  rgb(0,0,0,0)',
                        }}
                      >
                        <PreviewArea pngimg={`${images.mask_img_2}`} designimg={preview_large} width={100} />
                        {overmtrl === 'tag2' && (
                          <MaterialLbl>{Store.get('lang') === 'kr' ? '면' : 'cotton'}</MaterialLbl>
                        )}
                      </PreMaskTag>
                      <PreMaskTag
                        key={`mapping-${'3'}`}
                        onMouseEnter={() => {
                          this.handleMouseEnter('tag3');
                        }}
                        onMouseLeave={this.handleMouseLeave}
                        onClick={() => {
                          marketingApi.useClickDetailPreviewEffect(
                            this.state.viewData.product_name,
                            Store.get('lang') === 'kr' ? '플라스틱' : 'plastic',
                          );
                          this.setState({ isUnityView: false });
                          this.onMaskImg(images.mask_img_3);
                          this.setState({ mainPreviewSize: 'large' });
                        }}
                        style={{
                          border: maskpng === images.mask_img_3 ? '1px solid #fe8b07' : '1px solid  rgb(0,0,0,0)',
                        }}
                      >
                        <PreviewArea pngimg={`${images.mask_img_3}`} designimg={preview_large} width={100} />
                        {overmtrl === 'tag3' && (
                          <MaterialLbl>{Store.get('lang') === 'kr' ? '플라스틱' : 'plastic'}</MaterialLbl>
                        )}
                      </PreMaskTag>
                      <PreMaskTag
                        key={`mapping-${'4'}`}
                        onMouseEnter={() => {
                          this.handleMouseEnter('tag4');
                        }}
                        onMouseLeave={this.handleMouseLeave}
                        onClick={() => {
                          marketingApi.useClickDetailPreviewEffect(
                            this.state.viewData.product_name,
                            Store.get('lang') === 'kr' ? '종이' : 'paper',
                          );
                          this.setState({ isUnityView: false });
                          this.onMaskImg(images.mask_img_4);
                          this.setState({ mainPreviewSize: 'large' });
                        }}
                        style={{
                          border: maskpng === images.mask_img_4 ? '1px solid #fe8b07' : '1px solid  rgb(0,0,0,0)',
                        }}
                      >
                        <PreviewArea pngimg={`${images.mask_img_4}`} designimg={preview_large} width={100} />
                        {overmtrl === 'tag4' && (
                          <MaterialLbl>{Store.get('lang') === 'kr' ? '종이' : 'paper'}</MaterialLbl>
                        )}
                      </PreMaskTag>
                      <div
                        onMouseEnter={() => {
                          this.handleMouseEnter('tag6');
                        }}
                        onMouseLeave={this.handleMouseLeave}
                        onClick={() => {
                          this.onMaskImg(null);
                          this.setState({ mainPreviewSize: 'cropped' });
                        }}
                        style={{
                          border: maskpng === null ? '1px solid #fe8b07' : '1px solid  rgb(0,0,0,0)',
                          cursor: 'pointer',
                          position: 'relative',
                        }}
                      >
                        <PreviewArea designimg={preview_large} width={80} />
                        {overmtrl === 'tag6' && <MaterialLbl></MaterialLbl>}
                      </div>
                    </div>
                  </div>
                )}
                <HorizontalSp sp={'1.5vw'} />
              </MediaQuery>
              {/* ----------------- 모바일 ---------------------------*/}
              <MediaQuery max={919}>
                <div style={{ margin: '0px auto' }}>
                  {loading ? (
                    <div>
                      <div
                        style={{
                          width: 700,
                          height: 700,
                          textAlign: 'center',
                          display: 'table-cell',
                          verticalAlign: 'middle',
                        }}
                      >
                        <ScaleLoader color={'#fc8a06'} loading={true} size={150} />
                      </div>
                    </div>
                  ) : (
                    <>
                      <MainPreview
                        pngimg={maskpng}
                        mainPreviewSize={this.state.mainPreviewSize}
                        designimg={mainPreviewSize === 'cropped' ? preview_large : preview_large}
                        width={'80vw'}
                        verticalHorizonRadio={this.state.verticalHorizonRadio}
                        isUnityView={this.state.isUnityView}
                        product_name={this.state.viewData.product_name}
                        product_id={this.props.match.params.id}
                      />
                      <VerticalSp sp={5} />
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                        }}
                      >
                        <PreMaskTag
                          key={`mapping-${'0'}`}
                          onMouseEnter={() => {
                            this.handleMouseEnter('tag0');
                          }}
                          onMouseLeave={this.handleMouseLeave}
                          onClick={() => {
                            marketingApi.useClickDetailPreviewEffect(
                              this.state.viewData.product_name,
                              Store.get('lang') === 'kr' ? '린넨' : 'linen',
                            );
                            this.setState({ isUnityView: false });
                            this.onMaskImg(images.mask_img_0);
                            this.setState({ mainPreviewSize: 'large' });
                          }}
                          style={{
                            border: maskpng === images.mask_img_0 ? '1px solid #fe8b07' : '1px solid  rgb(0,0,0,0)',
                          }}
                        >
                          <PreviewArea pngimg={images.mask_img_0} designimg={preview_large} width={'15vw'} />
                          {overmtrl === 'tag0' && (
                            <MaterialLbl>{Store.get('lang') === 'kr' ? '린넨' : 'linen'}</MaterialLbl>
                          )}
                        </PreMaskTag>
                        <PreMaskTag
                          key={`mapping-${'1'}`}
                          onMouseEnter={() => {
                            this.handleMouseEnter('tag1');
                          }}
                          onMouseLeave={this.handleMouseLeave}
                          onClick={() => {
                            marketingApi.useClickDetailPreviewEffect(
                              this.state.viewData.product_name,
                              Store.get('lang') === 'kr' ? '쉬폰' : 'chiffon',
                            );
                            this.setState({ isUnityView: false });
                            this.onMaskImg(images.mask_img_1);
                            this.setState({ mainPreviewSize: 'large' });
                          }}
                          style={{
                            border: maskpng === images.mask_img_1 ? '1px solid #fe8b07' : '1px solid  rgb(0,0,0,0)',
                          }}
                        >
                          <PreviewArea pngimg={`${images.mask_img_1}`} designimg={preview_large} width={'15vw'} />
                          {overmtrl === 'tag1' && (
                            <MaterialLbl>{Store.get('lang') === 'kr' ? '쉬폰' : 'chiffon'}</MaterialLbl>
                          )}
                        </PreMaskTag>
                        <PreMaskTag
                          key={`mapping-${'2'}`}
                          onMouseEnter={() => {
                            this.handleMouseEnter('tag2');
                          }}
                          onMouseLeave={this.handleMouseLeave}
                          onClick={() => {
                            marketingApi.useClickDetailPreviewEffect(
                              this.state.viewData.product_name,
                              Store.get('lang') === 'kr' ? '면' : 'cotton',
                            );
                            this.setState({ isUnityView: false });
                            this.onMaskImg(images.mask_img_2);
                            this.setState({ mainPreviewSize: 'large' });
                          }}
                          style={{
                            border: maskpng === images.mask_img_2 ? '1px solid #fe8b07' : '1px solid  rgb(0,0,0,0)',
                          }}
                        >
                          <PreviewArea pngimg={`${images.mask_img_2}`} designimg={preview_large} width={'15vw'} />
                          {overmtrl === 'tag2' && (
                            <MaterialLbl>{Store.get('lang') === 'kr' ? '면' : 'cotton'}</MaterialLbl>
                          )}
                        </PreMaskTag>
                        <PreMaskTag
                          key={`mapping-${'3'}`}
                          onMouseEnter={() => {
                            this.handleMouseEnter('tag3');
                          }}
                          onMouseLeave={this.handleMouseLeave}
                          onClick={() => {
                            marketingApi.useClickDetailPreviewEffect(
                              this.state.viewData.product_name,
                              Store.get('lang') === 'kr' ? '플라스틱' : 'plastic',
                            );
                            this.setState({ isUnityView: false });
                            this.onMaskImg(images.mask_img_3);
                            this.setState({ mainPreviewSize: 'large' });
                          }}
                          style={{
                            border: maskpng === images.mask_img_3 ? '1px solid #fe8b07' : '1px solid  rgb(0,0,0,0)',
                          }}
                        >
                          <PreviewArea pngimg={`${images.mask_img_3}`} designimg={preview_large} width={'15vw'} />
                          {overmtrl === 'tag3' && (
                            <MaterialLbl>{Store.get('lang') === 'kr' ? '플라스틱' : 'plastic'}</MaterialLbl>
                          )}
                        </PreMaskTag>
                        <PreMaskTag
                          key={`mapping-${'4'}`}
                          onMouseEnter={() => {
                            this.handleMouseEnter('tag4');
                          }}
                          onMouseLeave={this.handleMouseLeave}
                          onClick={() => {
                            marketingApi.useClickDetailPreviewEffect(
                              this.state.viewData.product_name,
                              Store.get('lang') === 'kr' ? '종이' : 'paper',
                            );
                            this.setState({ isUnityView: false });
                            this.onMaskImg(images.mask_img_4);
                            this.setState({ mainPreviewSize: 'large' });
                          }}
                          style={{
                            border: maskpng === images.mask_img_4 ? '1px solid #fe8b07' : '1px solid  rgb(0,0,0,0)',
                          }}
                        >
                          <PreviewArea pngimg={`${images.mask_img_4}`} designimg={preview_large} width={'15vw'} />
                          {overmtrl === 'tag4' && (
                            <MaterialLbl>{Store.get('lang') === 'kr' ? '종이' : 'paper'}</MaterialLbl>
                          )}
                        </PreMaskTag>
                        <div
                          onMouseEnter={() => {
                            this.setState({ overmtrl: 'tag6' });
                          }}
                          onMouseLeave={() => {
                            this.setState({ overmtrl: '' });
                          }}
                          onClick={() => {
                            this.onMaskImg(null);
                            this.setState({ mainPreviewSize: 'cropped' });
                          }}
                          style={{
                            border: maskpng === null ? '1px solid #fe8b07' : '1px solid  rgb(0,0,0,0)',
                            cursor: 'pointer',
                            position: 'relative',
                          }}
                        >
                          <PreviewArea designimg={preview_large} width={'15vw'} />
                          {overmtrl === 'tag6' && !isMobile && <MaterialLbl></MaterialLbl>}
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </MediaQuery>
            </MediaQuery>
            {/* ---------------------- PC ----------------------*/}

            <MediaQuery min={920}>
              <div style={{ flex: 1 }}>
                <DesignTitle>{viewData.img_name}</DesignTitle>
                <div style={{ color: '#999999', padding: 5 }}>{viewData.input_time?.toLocaleString()}</div>
                <VerticalSp sp={10} />
                {license === '0' && (
                  <LicensBlock>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <LicenseType
                        typetitle={`Classic (${t('exclusive')})`}
                        typedes={t('commercial_unlimited_detail2')}
                      />
                      <VerticalSp sp={30} />
                    </div>
                  </LicensBlock>
                )}
                <HSLine bgcolor="#dddddd" />
                <VerticalSp sp={30} />
                <LicenseSpec label={t('included_files')} value={'PSD + PNG'} />
                <VerticalSp sp={22} />
                <LicenseSpec label={t('size')} value={size} />
                <VerticalSp sp={22} />
                <LicenseSpec label={t('resolution')} value={'300 dpi'} />
                <VerticalSp sp={22} />
                <LicenseSpec label={t('repeat_type')} value={t('repeat_tile')} />
                <VerticalSp sp={22} />
                <LicenseIcoSpec label={t('layerd_photoshop_psd')} img={images.icon_contain_chk} />
                <VerticalSp sp={22} />
                {/* <LicenseIcoSpec
                  label={t('vector_ai_or_eps')}
                  img={images.icon_contain_x}
                /> */}
                {/* <VerticalSp sp={30} /> */}
                <HSLine bgcolor="#dddddd" />
                <VerticalSp sp={30} />
                <LicensePrice unit={CURRENCY_CONFIG[lang].symbol} cost={cost} />
                <VerticalSp sp={30} />
                <CreditPrice></CreditPrice>
                {/* <PurchaseWithMyCredit onClick={() => this.goPurchseWithCredit()}></PurchaseWithMyCredit> */}
                <VerticalSp sp={30} />

                <HSLine bgcolor="#dddddd" />
                <VerticalSp sp={30} />

                {/* PC 버전 - 라디오 버튼: 결제됬으면 라디오 버튼 안보이고 결제 안됬으면 보임. 2024.02.13  */}
                {this.state && this.state.is_buy ? null : (
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                    <div
                      style={{ display: 'flex', width: '100%', flexDirection: 'row', justifyContent: 'space-between' }}
                    >
                      <RadioOption
                        value={purchasetype === 'general_pay'}
                        onClick={() => {
                          this.setState({ purchasetype: 'general_pay' });
                        }}
                        title={t('standard_payment')}
                      />
                    </div>

                    <VerticalSp sp={30} />
                    <div
                      style={{ display: 'flex', width: '100%', flexDirection: 'row', justifyContent: 'space-between' }}
                    >
                      <RadioOption
                        value={purchasetype === 'credit_pay'}
                        onClick={() => {
                          this.setState({ purchasetype: 'credit_pay' });
                        }}
                        title={t('credit_payment')}
                      />
                      {Store.get('lang') === 'kr' ? (
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                          <div style={{ alignItems: 'center', margin: '3px' }}>
                            <img style={{ content: `url(${images.credit_active})`, width: 20, height: 20 }} />
                          </div>
                          <div style={{ color: '#FF8A06', fontFamily: 'NSCJKrB', fontSize: '16px' }}>
                            {t('current_available')}
                            <span style={{ color: 'black' }}>
                              {' '}
                              &nbsp; {userCredit} {t('credit2')}
                            </span>
                          </div>
                        </div>
                      ) : userCredit <= 1 ? (
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                          <div style={{ alignItems: 'center', margin: '3px' }}>
                            <img style={{ content: `url(${images.credit_active})`, width: 20, height: 20 }} />
                          </div>
                          <div style={{ color: '#999999', fontFamily: 'NSCJKrB', fontSize: '16px' }}>
                            {t('current_available')}{' '}
                            <span style={{ color: 'black' }}>
                              {' '}
                              &nbsp; {userCredit} {t('credit2')}
                            </span>
                          </div>
                        </div>
                      ) : (
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                          <div style={{ alignItems: 'center', margin: '3px' }}>
                            <img style={{ content: `url(${images.credit_active})`, width: 20, height: 20 }} />
                          </div>
                          <div style={{ color: '#999999', fontFamily: 'NSCJKrB', fontSize: '16px' }}>
                            {t('current_available')}{' '}
                            <span style={{ color: 'black' }}> &nbsp; {userCredit} credits</span>
                          </div>
                        </div>
                      )}
                    </div>
                    <VerticalSp sp={30} />
                  </div>
                )}

                {/* <HSLine bgcolor="#dddddd" /> */}
                <VerticalSp sp={30} />
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  {is_buy ? (
                    <>
                      {button === 'download' && (
                        <CustomButton
                          onClick={this.downloadImageOne}
                          style={{ color: 'white', backgroundColor: '#fe8b07' }}
                        >
                          {t('download')}
                        </CustomButton>
                      )}
                      {button === 'converting' && (
                        <CustomButton
                          style={{ backgroundColor: '#D9D9D9', border: '1px solid #D9D9D9', color: '#686868' }}
                        >
                          <div style={{ width: 24, marginRight: 5 }}>
                            <RotatedImage alt="" style={{ width: 24 }} src={images.img_generating2} />
                          </div>
                          {t('converting')}
                        </CustomButton>
                      )}
                      {button === 'downloading' && (
                        <CustomButton
                          style={{ backgroundColor: '#D9D9D9', border: '1px solid #D9D9D9', color: '#686868' }}
                        >
                          {downloading}%
                        </CustomButton>
                      )}
                    </>
                  ) : (
                    <>
                      <CartButton id={this.props.match.params.id} ShowBasketModal={this.ShowBasketModal}>
                        {t('ai_basket')}
                      </CartButton>
                      <HorizontalSp sp={8} />

                      {Store.get('lang') === 'kr' ? ( //한국어인 경우
                        purchasetype === 'general_pay' ? (
                          <CustomButton
                            onClick={() => {
                              // const username = store.getState().username;
                              //   if(username === 'emptyusertextile@gmail.com'){
                              //     this.openTossPaymentModal();
                              //   }else{
                              //     this.goPurchase('eximbay')
                              //   }
                              this.openTossPaymentModal();
                            }}
                            style={{ color: 'white', backgroundColor: '#fe8b07' }}
                          >
                            {t('buy')}
                          </CustomButton>
                        ) : (
                          <CustomButton
                            onClick={() => this.goPurchseWithCredit()}
                            style={{ color: 'white', backgroundColor: '#fe8b07' }}
                          >
                            {t('cerit_pay2')}
                          </CustomButton>
                        )
                      ) : //외국어인 경우
                      purchasetype === 'general_pay' ? (
                        <CustomButton
                          onClick={() => this.ShowPaymethodModal()}
                          style={{ color: 'white', backgroundColor: '#fe8b07' }}
                        >
                          {t('buy')}
                        </CustomButton>
                      ) : (
                        <CustomButton
                          onClick={() => this.goPurchseWithCredit()}
                          style={{ color: 'white', backgroundColor: '#fe8b07' }}
                        >
                          {t('cerit_pay2')}
                        </CustomButton>
                      )}
                    </>
                  )}
                </div>
              </div>
            </MediaQuery>
          </RowCenter>
          {/* 모바일 */}
          <MediaQuery max={919}>
            <div style={{ flex: 1 }}>
              <DesignTitle>{viewData.img_name}</DesignTitle>
              <div style={{ color: '#999999', padding: 5 }}>{viewData.input_time?.toLocaleString()}</div>
              <VerticalSp sp={10} />
              {license === '0' && (
                <LicensBlock>
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <LicenseType
                      typetitle={`Classic (${t('exclusive')})`}
                      typedes={t('commercial_unlimited_detail2')}
                    />
                    <VerticalSp sp={30} />
                  </div>
                </LicensBlock>
              )}
              <HSLine bgcolor="#dddddd" />
              <VerticalSp sp={30} />
              <LicenseSpec label={t('included_files')} value={'PSD + PNG'} />
              <VerticalSp sp={22} />
              <LicenseSpec label={t('size')} value={size} />
              <VerticalSp sp={22} />
              <v label={t('resolution')} value={'300 dpi'} />
              <VerticalSp sp={22} />
              <LicenseSpec label={t('repeat_type')} value={t('repeat_tile')} />
              <VerticalSp sp={22} />
              <LicenseIcoSpec label={t('layerd_photoshop_psd')} img={images.icon_contain_chk} />
              <VerticalSp sp={22} />
              <HSLine bgcolor="#dddddd" />
              <VerticalSp sp={30} />
              <LicensePrice unit={CURRENCY_CONFIG[lang].symbol} cost={cost} />
              <VerticalSp sp={30} />
              <CreditPrice></CreditPrice>
              <VerticalSp sp={10} />
              <HSLine bgcolor="#dddddd" />

              <VerticalSp sp={30} />

              {/* 모바일버전 - 라디오 버튼: 결제됬으면 라디오 버튼 안보이고 결제 안됬으면 보임. 2024.02.13  */}
              {this.state && this.state.is_buy ? null : (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                  <div
                    style={{ display: 'flex', width: '100%', flexDirection: 'row', justifyContent: 'space-between' }}
                  >
                    <RadioOption
                      value={purchasetype === 'general_pay'}
                      onClick={() => {
                        this.setState({ purchasetype: 'general_pay' });
                      }}
                      title={t('standard_payment')}
                    />
                  </div>

                  <VerticalSp sp={30} />
                  <div
                    style={{ display: 'flex', width: '100%', flexDirection: 'row', justifyContent: 'space-between' }}
                  >
                    <RadioOption
                      value={purchasetype === 'credit_pay'}
                      onClick={() => {
                        this.setState({ purchasetype: 'credit_pay' });
                      }}
                      title={t('credit_payment')}
                    />

                    {Store.get('lang') === 'kr' ? (
                      <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <div style={{ alignItems: 'center', margin: '3px' }}>
                          <img style={{ content: `url(${images.credit_active})`, width: 20, height: 20 }} />
                        </div>
                        <div style={{ color: '#FF8A06', fontFamily: 'NSCJKrR', fontSize: '16px' }}>
                          {t('current_available')}{' '}
                          <span style={{ color: 'black' }}>
                            {' '}
                            &nbsp; {userCredit} {t('credit2')}
                          </span>
                        </div>
                      </div>
                    ) : userCredit <= 1 ? (
                      <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <div style={{ alignItems: 'center', margin: '3px' }}>
                          <img style={{ content: `url(${images.credit_active})`, width: 20, height: 20 }} />
                        </div>
                        <div style={{ color: '#999999', fontFamily: 'NSCJKrR', fontSize: '16px' }}>
                          {t('current_available')}{' '}
                          <span style={{ color: 'black' }}>
                            {' '}
                            &nbsp; {userCredit} {t('credit2')}
                          </span>
                        </div>
                      </div>
                    ) : (
                      <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <div style={{ alignItems: 'center', margin: '3px' }}>
                          <img style={{ content: `url(${images.credit_active})`, width: 20, height: 20 }} />
                        </div>
                        <div style={{ color: '#999999', fontFamily: 'NSCJKrR', fontSize: '16px' }}>
                          {t('current_available')} <span style={{ color: 'black' }}> &nbsp;{userCredit} credits</span>
                        </div>
                      </div>
                    )}
                  </div>
                  <VerticalSp sp={30} />
                </div>
              )}

              {/* <VerticalSp sp={30} /> */}
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {is_buy ? (
                  <>
                    {button === 'download' && (
                      <CustomButton
                        onClick={this.downloadImageOne}
                        style={{ color: 'white', backgroundColor: '#fe8b07' }}
                      >
                        {t('download')}
                      </CustomButton>
                    )}
                    {button === 'converting' && (
                      <CustomButton
                        style={{ backgroundColor: '#D9D9D9', border: '1px solid #D9D9D9', color: '#686868' }}
                      >
                        <div style={{ width: 24, marginRight: 5 }}>
                          <RotatedImage alt="" style={{ width: 24 }} src={images.img_generating2} />
                        </div>
                        {t('converting')}
                      </CustomButton>
                    )}
                    {button === 'downloading' && (
                      <CustomButton
                        style={{ backgroundColor: '#D9D9D9', border: '1px solid #D9D9D9', color: '#686868' }}
                      >
                        {downloading}%
                      </CustomButton>
                    )}
                  </>
                ) : (
                  <>
                    <CustomButtonMobile onClick={this.getCart}>{t('ai_basket')}</CustomButtonMobile>
                    <HorizontalSp sp={8} />
                    {Store.get('lang') === 'kr' ? (
                      purchasetype === 'general_pay' ? (
                        <CustomButtonMobile
                          onClick={() => {
                            // const username = store.getState().username;
                            //   if(username === 'emptyusertextile@gmail.com'){
                            //     this.openTossPaymentModal();
                            //   }else{
                            //     this.goPurchase('eximbay')
                            //   }
                            this.openTossPaymentModal();
                          }}
                          style={{ color: 'white', backgroundColor: '#fe8b07' }}
                        >
                          {t('buy')}
                        </CustomButtonMobile>
                      ) : (
                        <CustomButtonMobile
                          onClick={() => this.goPurchseWithCredit()}
                          style={{ color: 'white', backgroundColor: '#fe8b07' }}
                        >
                          {t('cerit_pay2')}
                        </CustomButtonMobile>
                      )
                    ) : purchasetype === 'general_pay' ? (
                      <CustomButtonMobile
                        onClick={() => this.ShowPaymethodModal()}
                        style={{ color: 'white', backgroundColor: '#fe8b07' }}
                      >
                        {t('buy')}
                      </CustomButtonMobile>
                    ) : (
                      <CustomButtonMobile
                        onClick={() => this.goPurchseWithCredit()}
                        style={{ color: 'white', backgroundColor: '#fe8b07' }}
                      >
                        {t('cerit_pay2')}
                      </CustomButtonMobile>
                    )}
                  </>
                )}
              </div>
            </div>
          </MediaQuery>

          <ChooseCardOrPayparModal
            show={paymethodmodal}
            onClose={this.closePaymethodModal}
            onSelFst={this.SelectFstPayMethod}
            onSelSnd={this.SelectSndPayMethod}
          />
        </ContentsWrap>
        <VerticalSp sp={'3.8vw'} style={{ minHeight: 30 }} />
        <BasketModal show={showbasket} onClose={this.closeBasketModal} onConfirm={this.goBasket} />
        <PlzLoginModal props={this.props} show={showPlzLoginModal} onClose={this.closePlzLoginModal} />
        <IsShortOfCreditModal
          props={this.props}
          show={isLackCreditModal}
          onClose={this.closeIsLakeCreditModal}
          onConfirm={this.onGoAIGeneratePrice}
        />
        <TossPaymentModal
          show={this.state.tossPaymentModal}
          onClose={this.closeTossPaymentModal}
          productName={this.state.productName}
          payAmount={this.state.amount}
          successUrl={`${process.env.REACT_APP_FRONT_URL}/generate/result/detail/${this.props.match.params.id}`}
          user_id={store.getState().user_id}
          user_uuid={store.getState().user_uuid}
        />
      </>
    );
  }
}

export default withTranslation()(withRouter(AIGenerateDetail));
